"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _truncate2 = _interopRequireDefault(require("lodash/truncate"));
var _trim2 = _interopRequireDefault(require("lodash/trim"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var EntryFunc = /*#__PURE__*/function () {
  function EntryFunc() {
    var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, EntryFunc);
    var _func$type = func.type,
      type = _func$type === void 0 ? 'normal' : _func$type,
      _func$id = func.id,
      id = _func$id === void 0 ? Entry.generateHash() : _func$id,
      _func$localVariables = func.localVariables,
      localVariables = _func$localVariables === void 0 ? [] : _func$localVariables,
      _func$useLocalVariabl = func.useLocalVariables,
      useLocalVariables = _func$useLocalVariabl === void 0 ? false : _func$useLocalVariabl;
    this.id = id;
    this.type = type;
    this.localVariables = localVariables;
    this.useLocalVariables = useLocalVariables;
    var content;
    //inspect empty content
    if (func && func.content && func.content.length > 4) {
      content = func.content;
    }
    var codeType = 'function_create';
    if (type === 'value') {
      codeType = 'function_create_value';
    }
    this.content = content ? new Entry.Code(content) : new Entry.Code([[{
      type: codeType,
      copyable: false,
      deletable: false,
      x: 40,
      y: 40
    }]]);
    this.block = null;
    this.blockMenuBlock = null;
    this.hashMap = {};
    this.paramMap = {};
    EntryFunc._generateFunctionSchema(this.id, type);
    if (func && func.content) {
      var blockMap = this.content._blockMap;
      for (var key in blockMap) {
        EntryFunc.registerParamBlock(blockMap[key].type);
      }
      EntryFunc.generateWsBlock(this);
    }
    EntryFunc.registerFunction(this);
    EntryFunc.updateMenu();
  }
  return (0, _createClass2["default"])(EntryFunc, [{
    key: "destroy",
    value: function destroy() {
      this.blockMenuBlock && this.blockMenuBlock.destroy();
    }
  }, {
    key: "edit",
    value: function edit() {
      if (EntryFunc.isEdit) {
        return;
      }
      EntryFunc.isEdit = true;
      Entry.getMainWS().blockMenu.deleteRendered('variable');
      if (!EntryFunc.svg) {
        EntryFunc.isEdit = EntryFunc.initEditView();
      } else {
        this.parentView.appendChild(this.svg);
      }
    }
  }, {
    key: "generateBlock",
    value: function generateBlock() {
      var generatedInfo = EntryFunc.generateBlock(this);
      this.block = generatedInfo.block;
      this.description = generatedInfo.description;
    }
  }, {
    key: "defaultLocalVariable",
    value: function defaultLocalVariable(isForce) {
      return {
        name: this.makeLocalVariableName(isForce),
        value: 0
      };
    }
  }, {
    key: "setLocalVariableLength",
    value: function setLocalVariableLength(length) {
      if (!this.localVariables) {
        this.localVariables = [];
      }
      if (this.localVariables.length >= length) {
        this.localVariables.splice(length, this.localVariables.length - length);
      } else {
        var max = length - this.localVariables.length;
        for (var i = 0; i < max; i++) {
          this.localVariables.push(this.defaultLocalVariable(true));
        }
      }
      Entry.variableContainer && Entry.variableContainer.updateFuncScrollBar(this);
    }
  }, {
    key: "appendLocalVariable",
    value: function appendLocalVariable(value) {
      if (!this.localVariables) {
        this.localVariables = [];
      }
      this.localVariables.push(value);
      Entry.variableContainer && Entry.variableContainer.updateFuncScrollBar(this);
    }
  }, {
    key: "insertFuncLocalVariable",
    value: function insertFuncLocalVariable(value, index) {
      if (!this.localVariables) {
        this.localVariables = [];
      }
      this.localVariables.splice(index, 0, value);
      Entry.variableContainer && Entry.variableContainer.updateFuncScrollBar(this);
    }
  }, {
    key: "removeLocalVariable",
    value: function removeLocalVariable(idx) {
      if (!Array.isArray(this.localVariables)) {
        return;
      }
      if (this.localVariables.length >= idx) {
        this.localVariables.splice(idx, 1);
      }
      Entry.variableContainer && Entry.variableContainer.updateFuncScrollBar(this);
    }
  }, {
    key: "removeLastLocalVariable",
    value: function removeLastLocalVariable() {
      this.removeLocalVariable(this.localVariables.length - 1);
    }
  }, {
    key: "toggleFunctionUseLocalVariables",
    value: function toggleFunctionUseLocalVariables() {
      this.useLocalVariables = !this.useLocalVariables;
      Entry.variableContainer && Entry.variableContainer.updateFuncSettingView(this);
      EntryFunc.updateMenu();
    }
  }, {
    key: "getLocalVariables",
    value: function getLocalVariables() {
      return this.localVariables;
    }
  }, {
    key: "makeLocalVariableName",
    value: function makeLocalVariableName(isForce) {
      var name = Lang.Workspace.local_variable;
      if (this.checkLocalVariableName(name)) {
        name = Entry.getOrderedName(name, this.localVariables, 'name');
        if (!isForce) {
          Entry.toast.warning(Lang.Workspace.local_variable_rename, Lang.Workspace.local_variable_dup);
        }
      }
      return name;
    }
  }, {
    key: "checkLocalVariableName",
    value: function checkLocalVariableName(name) {
      return this.localVariables.some(function (localVariable) {
        return localVariable.name === name;
      });
    }
  }, {
    key: "changeNameLocalVariable",
    value: function changeNameLocalVariable(name, index) {
      var localVariable = this.localVariables[index];
      localVariable.name = name;
      var _Entry = Entry,
        playground = _Entry.playground;
      if (playground) {
        playground.blockMenu.deleteRendered('func');
        playground.reloadPlayground();
      }
    }
  }, {
    key: "getValue",
    value: function getValue(variableId, localVariables) {
      var localVariable = (0, _find2["default"])(localVariables || this.localVariables, function (localVariable) {
        return localVariable.id === variableId;
      });
      return (localVariable === null || localVariable === void 0 ? void 0 : localVariable.value) || 0;
    }
  }, {
    key: "setValue",
    value: function setValue(value, variableId, localVariables) {
      var localVariable = (0, _find2["default"])(localVariables || this.localVariables, function (localVariable) {
        return localVariable.id === variableId;
      });
      localVariable.value = value;
    }
  }, {
    key: "getBlockById",
    value: function getBlockById(blockId) {
      var _this$content;
      return this === null || this === void 0 || (_this$content = this.content) === null || _this$content === void 0 ? void 0 : _this$content.findById(blockId);
    }
  }, {
    key: "getFuncBlockByFuncId",
    value: function getFuncBlockByFuncId(funcId) {
      var _this$content2;
      return this === null || this === void 0 || (_this$content2 = this.content) === null || _this$content2 === void 0 ? void 0 : _this$content2.findByType(funcId);
    }
  }, {
    key: "getBlockByParamId",
    value: function getBlockByParamId(paramId) {
      var _this$content3;
      return this === null || this === void 0 || (_this$content3 = this.content) === null || _this$content3 === void 0 ? void 0 : _this$content3.findByParamId(paramId);
    }
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot() {
      this.snapshot_ = {
        localVariables: (0, _cloneDeep2["default"])(this.localVariables)
      };
    }
  }, {
    key: "loadSnapshot",
    value: function loadSnapshot() {
      if (!this.snapshot_) {
        return;
      }
      var localVariables = this.snapshot_.localVariables;
      this.localVariables = localVariables;
      delete this.snapshot_;
    }
  }], [{
    key: "changeFunctionName",
    value: function changeFunctionName(name) {
      Entry.Mutator.mutate('function_name', {
        template: "".concat(Lang.Workspace.func, ": ").concat((0, _trim2["default"])((0, _truncate2["default"])(name, {
          length: 20
        })))
      }, {
        type: 'noChange',
        isRestore: undefined
      });
    }
  }, {
    key: "initBlock",
    value: function initBlock(blockMenu) {
      blockMenu.banClass('functionEdit', true);
      blockMenu.banClass('useLocalVariables', true);
      this.changeFunctionName('');
    }
  }, {
    key: "registerFunction",
    value: function registerFunction(func) {
      var workspace = Entry && Entry.getMainWS();
      if (!workspace) {
        return;
      }
      var blockMenu = workspace.getBlockMenu();
      var menuCode = blockMenu.code;
      var index = undefined;
      if (this._fieldLabel) {
        index = menuCode.getThreadIndex(this._fieldLabel.thread);
      }
      this._targetFuncBlock = menuCode.createThread([{
        type: "func_".concat(func.id),
        category: 'func',
        x: -9999
      }], index);
      func.blockMenuBlock = this._targetFuncBlock;
    }
  }, {
    key: "clearThreads",
    value: function clearThreads() {
      this.threads = {};
    }
  }, {
    key: "edit",
    value: function edit(func) {
      var _this = this;
      var funcElement = func;
      if (typeof func === 'string') {
        funcElement = Entry.variableContainer.getFunction(/(func_)?(.*)/.exec(func)[2]);
      }
      if (!funcElement) {
        console.error('no function');
        return;
      }
      this.unbindFuncChangeEvent();
      this.unbindWorkspaceStateChangeEvent();
      this.cancelEdit();
      this.targetFunc = funcElement;
      EntryFunc.isEdit = true;
      Entry.getMainWS().blockMenu.deleteRendered('variable');
      if (this.initEditView(funcElement.content) === false) {
        EntryFunc.isEdit = false;
        return;
      } // edit fail
      this.bindFuncChangeEvent(funcElement);
      this.updateMenu();
      requestAnimationFrame(function () {
        var schema = Entry.block["func_".concat(funcElement.id)];
        if (schema && schema.paramsBackupEvent) {
          schema.paramsBackupEvent.notify();
        }
        _this._backupContent = funcElement.content.stringify();
        _this._backupOption = {
          type: funcElement.type,
          useLocalVariables: funcElement.useLocalVariables,
          localVariables: (0, _cloneDeep2["default"])(funcElement.localVariables)
        };
        Entry.getMainWS().overlayBoard.reDraw();
      });
    }
  }, {
    key: "initEditView",
    value: function initEditView(content) {
      var _this2 = this;
      if (this.targetFunc) {
        var defBlock = this.targetFunc.content.getEventMap('funcDef')[0];
        if (defBlock) {
          var outputBlock = defBlock.params[0];
          var functionNmaeTemplate = '';
          var booleanIndex = 0;
          var stringIndex = 0;
          while (outputBlock) {
            var value = outputBlock.params[0];
            var valueType = value.type;
            switch (outputBlock.type) {
              case 'function_field_label':
                functionNmaeTemplate = "".concat(functionNmaeTemplate, " ").concat(value);
                break;
              case 'function_field_boolean':
                booleanIndex++;
                // eslint-disable-next-line max-len
                functionNmaeTemplate += " <".concat(Lang.Blocks.FUNCTION_logical_variable, " ").concat(booleanIndex, ">");
                break;
              case 'function_field_string':
                stringIndex++;
                // eslint-disable-next-line max-len
                functionNmaeTemplate += " (".concat(Lang.Blocks.FUNCTION_character_variable, " ").concat(stringIndex, ")");
                break;
            }
            outputBlock = outputBlock.getOutputBlock();
          }
          this.changeFunctionName(functionNmaeTemplate);
        }
      }
      if (!this.menuCode) {
        this.setupMenuCode();
      }
      var workspace = Entry.getMainWS();
      if (workspace.setMode(Entry.Workspace.MODE_OVERLAYBOARD) === false) {
        this.endEdit('cancelEdit');
        return false;
      }
      workspace.changeOverlayBoardCode(content);
      this._workspaceStateEvent = workspace.changeEvent.attach(this, function () {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cancelEdit';
        _this2.endEdit(message);
        if (workspace.getMode() === Entry.Workspace.MODE_VIMBOARD) {
          workspace.blockMenu.banClass('functionInit');
        }
      });
      content.board.alignThreads();
      return true;
    }
  }, {
    key: "endEdit",
    value: function endEdit(message) {
      this.unbindFuncChangeEvent();
      this.unbindWorkspaceStateChangeEvent();
      var targetFuncId = this.targetFunc.id;
      if (this.targetFunc && this.targetFunc.content) {
        this.targetFunc.content.destroyView();
      }
      switch (message) {
        case 'save':
          this.save();
          break;
        case 'cancelEdit':
          this.cancelEdit();
          break;
      }
      this._backupContent = null;
      this._backupOption = null;
      delete this.targetFunc;
      EntryFunc.isEdit = false;
      var workspace = Entry.getMainWS();
      var blockMenu = workspace.getBlockMenu();
      blockMenu.deleteRendered('variable');
      var blockSchema = Entry.block["func_".concat(targetFuncId)];
      if (blockSchema && blockSchema.destroyParamsBackupEvent) {
        blockSchema.destroyParamsBackupEvent.notify();
      }
      this.updateMenu();
    }
  }, {
    key: "save",
    value: function save() {
      this.targetFunc.generateBlock(true);
      Entry.variableContainer.saveFunction(this.targetFunc);
      this._restoreBoardToVimBoard();
    }
  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      if (!this.targetFunc) {
        return;
      }
      if (!this.targetFunc.block) {
        this._targetFuncBlock.destroy();
        delete Entry.variableContainer.functions_[this.targetFunc.id];
        delete Entry.variableContainer.selected;
      } else {
        if (this._backupContent) {
          this.targetFunc.content.load(this._backupContent);
          this.targetFunc.useLocalVariables = this._backupOption.useLocalVariables;
          this.targetFunc.localVariables = this._backupOption.localVariables;
          this.changeType(this.targetFunc, this._backupOption.type);
          this._generateFunctionSchema(this.targetFunc.id);
          this.generateWsBlock(this.targetFunc);
        }
      }
      Entry.variableContainer.updateList();
      this._restoreBoardToVimBoard();
    }
  }, {
    key: "setupMenuCode",
    value: function setupMenuCode() {
      var workspace = Entry.getMainWS();
      if (!workspace) {
        return;
      }
      var blockMenu = workspace.getBlockMenu();
      var menuCode = blockMenu.code;
      var CATEGORY = 'func';
      this._fieldLabel = menuCode.createThread([{
        type: 'function_field_label',
        copyable: false,
        category: CATEGORY,
        x: -9999
      }]).getFirstBlock();
      this._fieldString = menuCode.createThread([{
        type: 'function_field_string',
        category: CATEGORY,
        x: -9999,
        copyable: false,
        assemble: false,
        params: [{
          type: this.requestParamBlock('string')
        }]
      }]).getFirstBlock();
      this._fieldBoolean = menuCode.createThread([{
        type: 'function_field_boolean',
        copyable: false,
        assemble: false,
        category: CATEGORY,
        x: -9999,
        params: [{
          type: this.requestParamBlock('boolean')
        }]
      }]).getFirstBlock();
      this.menuCode = menuCode; // TODO Destroy 혹은 cleanProject 같은 로직이 동작했을때 삭제 필요
      blockMenu.align();
    }
  }, {
    key: "refreshMenuCode",
    value: function refreshMenuCode() {
      if (!Entry.playground.mainWorkspace) {
        return;
      }
      if (!this.menuCode) {
        this.setupMenuCode();
      }
      this._fieldString.params[0].changeType(this.requestParamBlock('string'));
      this._fieldBoolean.params[0].changeType(this.requestParamBlock('boolean'));
    }
  }, {
    key: "requestParamBlock",
    value: function requestParamBlock(type) {
      var blockPrototype;
      switch (type) {
        case 'string':
          blockPrototype = Entry.block.function_param_string;
          break;
        case 'boolean':
          blockPrototype = Entry.block.function_param_boolean;
          break;
        default:
          return null;
      }
      var blockType = "".concat(type, "Param_").concat(Entry.generateHash());
      Entry.block[blockType] = EntryFunc.createParamBlock(blockType, blockPrototype, type);
      return blockType;
    }
  }, {
    key: "registerParamBlock",
    value: function registerParamBlock(type) {
      if (!type) {
        return;
      }
      var blockPrototype;
      if (type.indexOf('stringParam') > -1) {
        blockPrototype = Entry.block.function_param_string;
      } else if (type.indexOf('booleanParam') > -1) {
        blockPrototype = Entry.block.function_param_boolean;
      }

      //not a function param block
      if (!blockPrototype) {
        return;
      }
      EntryFunc.createParamBlock(type, blockPrototype, type);
    }
  }, {
    key: "createParamBlock",
    value: function createParamBlock(type, blockPrototype, originalType) {
      var originalTypeFullName = /string/gi.test(originalType) ? 'function_param_string' : 'function_param_boolean';
      var BlockSchema = function BlockSchema() {};
      BlockSchema.prototype = blockPrototype;
      BlockSchema = new BlockSchema();
      BlockSchema.changeEvent = new Entry.Event();
      BlockSchema.template = Lang.template[originalTypeFullName];
      BlockSchema.fontColor = blockPrototype.fontColor || '#FFF';
      Entry.block[type] = BlockSchema;
      return BlockSchema;
    }
  }, {
    key: "updateMenu",
    value: function updateMenu() {
      var workspace = Entry.getMainWS();
      if (!workspace) {
        return;
      }
      var blockMenu = workspace.getBlockMenu();
      if (this.targetFunc) {
        !this.menuCode && this.setupMenuCode();
        blockMenu.banClass('functionInit', true);
        blockMenu.unbanClass('functionEdit', true);
        if (this.targetFunc && this.targetFunc.useLocalVariables) {
          blockMenu.unbanClass('useLocalVariables', true);
        } else {
          blockMenu.banClass('useLocalVariables', true);
        }
        Entry.variableContainer && Entry.variableContainer.updateFuncSettingView(this.targetFunc);
      } else {
        !workspace.isVimMode() && blockMenu.unbanClass('functionInit', true);
        blockMenu.banClass('functionEdit', true);
        blockMenu.banClass('useLocalVariables', true);
      }
      blockMenu.lastSelector === 'func' && blockMenu.align();
    }
  }, {
    key: "generateBlock",
    value: function generateBlock(func) {
      var blockSchema = Entry.block["func_".concat(func.id)];
      var block = {
        template: blockSchema.template,
        params: blockSchema.params
      };
      var reg = /(%\d)/im;
      var templateParams = blockSchema.template.split(reg);
      var description = '';
      var booleanIndex = 0;
      var stringIndex = 0;
      for (var i in templateParams) {
        var templateChunk = templateParams[i];
        if (reg.test(templateChunk)) {
          var paramIndex = Number(templateChunk.split('%')[1]) - 1;
          var param = blockSchema.params[paramIndex];
          if (param.accept === 'boolean') {
            description += Lang.template.function_param_boolean + (booleanIndex ? booleanIndex : '');
            booleanIndex++;
          } else if (param.type !== 'Indicator') {
            description += Lang.template.function_param_string + (stringIndex ? stringIndex : '');
            stringIndex++;
          }
        } else {
          description += templateChunk;
        }
      }
      return {
        block: block,
        description: description
      };
    }
  }, {
    key: "generateWsBlock",
    value: function generateWsBlock(target, isRestore) {
      this.unbindFuncChangeEvent();
      var targetFunc = target ? target : this.targetFunc;
      var defBlock = targetFunc.content.getEventMap('funcDef')[0];
      if (!defBlock) {
        return;
      }
      var outputBlock = defBlock.params[0];
      var booleanIndex = 0;
      var stringIndex = 0;
      var schemaParams = [];
      var schemaTemplate = '';
      var functionNmaeTemplate = '';
      var hashMap = targetFunc.hashMap;
      var paramMap = targetFunc.paramMap;
      var blockIds = [];
      while (outputBlock) {
        var value = outputBlock.params[0];
        var valueType = value.type;
        switch (outputBlock.type) {
          case 'function_field_label':
            schemaTemplate = "".concat(schemaTemplate, " ").concat(value);
            functionNmaeTemplate = "".concat(functionNmaeTemplate, " ").concat(value);
            break;
          case 'function_field_boolean':
            Entry.Mutator.mutate(valueType, {
              template: "".concat(Lang.Blocks.FUNCTION_logical_variable, " ").concat(booleanIndex + 1)
            });
            hashMap[valueType] = false;
            paramMap[valueType] = booleanIndex + stringIndex;
            booleanIndex++;
            schemaParams.push({
              type: 'Block',
              accept: 'boolean'
            });
            schemaTemplate += " %".concat(booleanIndex + stringIndex);

            // eslint-disable-next-line max-len
            functionNmaeTemplate += " <".concat(Lang.Blocks.FUNCTION_logical_variable, " ").concat(booleanIndex, ">");
            blockIds.push(outputBlock.id);
            break;
          case 'function_field_string':
            Entry.Mutator.mutate(valueType, {
              template: "".concat(Lang.Blocks.FUNCTION_character_variable, " ").concat(stringIndex + 1)
            });
            hashMap[valueType] = false;
            paramMap[valueType] = booleanIndex + stringIndex;
            stringIndex++;
            schemaTemplate += " %".concat(booleanIndex + stringIndex);

            // eslint-disable-next-line max-len
            functionNmaeTemplate += " (".concat(Lang.Blocks.FUNCTION_character_variable, " ").concat(stringIndex, ")");
            schemaParams.push({
              type: 'Block',
              accept: 'string'
            });
            blockIds.push(outputBlock.id);
            break;
        }
        outputBlock = outputBlock.getOutputBlock();
      }
      this.changeFunctionName(functionNmaeTemplate);
      if (targetFunc.type !== 'value') {
        schemaTemplate += " %".concat(booleanIndex + stringIndex + 1);
        schemaParams.push({
          type: 'Indicator',
          img: 'block_icon/func_icon.svg',
          size: 12
        });
      }
      var funcName = "func_".concat(targetFunc.id);
      var block = Entry.block[funcName];
      var originParams = block.params.slice(0, block.params.length - 1);
      var newParams = schemaParams.slice(0, schemaParams.length - 1);
      var originParamsLength = originParams.length;
      var newParamsLength = newParams.length;
      var changeData = {};
      if (newParamsLength > originParamsLength) {
        var outputBlockIds = targetFunc.outputBlockIds;
        if (outputBlockIds) {
          var startPos = 0;
          while (outputBlockIds[startPos] === blockIds[startPos]) {
            if (!outputBlockIds[startPos]) {
              break;
            }
            startPos++;
          }
          var endPos = 0;
          while (outputBlockIds[outputBlockIds.length - endPos - 1] === blockIds[blockIds.length - endPos - 1]) {
            if (!outputBlockIds[outputBlockIds.length - endPos - 1]) {
              break;
            }
            endPos++;
          }
          endPos = blockIds.length - endPos - 1;
          changeData = {
            type: 'insert',
            startPos: startPos,
            endPos: endPos
          };
        }
      } else if (newParamsLength < originParamsLength) {
        changeData = {
          type: 'cut',
          pos: newParamsLength
        };
      } else {
        changeData = {
          type: 'noChange'
        };
      }
      changeData.isRestore = isRestore;
      targetFunc.outputBlockIds = blockIds;
      Entry.Mutator.mutate(funcName, {
        params: schemaParams,
        template: schemaTemplate
      }, changeData);
      for (var key in hashMap) {
        var state = hashMap[key];
        if (state) {
          var text = /string/.test(key) ? Lang.Blocks.FUNCTION_character_variable : Lang.Blocks.FUNCTION_logical_variable;
          Entry.Mutator.mutate(key, {
            template: text
          });
        } else {
          hashMap[key] = true;
        }
      }
      this.bindFuncChangeEvent(targetFunc);
    }
  }, {
    key: "bindFuncChangeEvent",
    value: function bindFuncChangeEvent(targetFunc) {
      var selectedTargetFunc = targetFunc ? targetFunc : this.targetFunc;
      if (!this._funcChangeEvent && selectedTargetFunc.content.getEventMap('funcDef')[0].view) {
        this._funcChangeEvent = selectedTargetFunc.content.getEventMap('funcDef')[0].view._contents[1].changeEvent.attach(this, this.generateWsBlock);
      }
    }
  }, {
    key: "unbindFuncChangeEvent",
    value: function unbindFuncChangeEvent() {
      if (!this._funcChangeEvent) {
        return;
      }
      this._funcChangeEvent.destroy();
      delete this._funcChangeEvent;
    }
  }, {
    key: "unbindWorkspaceStateChangeEvent",
    value: function unbindWorkspaceStateChangeEvent() {
      var event = this._workspaceStateEvent;
      if (!event) {
        return;
      }
      event.destroy();
      delete this._workspaceStateEvent;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.isEdit) {
        this.endEdit();
      }
      this.menuCode = undefined;
    }
  }, {
    key: "changeType",
    value: function changeType(func) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';
      func.destroy();
      func.type = type;
      delete func.block;
      delete func.blockMenuBlock;
      EntryFunc._generateFunctionSchema(func.id, type, true);
      var tempContent = func.content.toJSON();
      if (func && func.content) {
        var blockMap = func.content._blockMap;
        for (var key in blockMap) {
          EntryFunc.registerParamBlock(blockMap[key].type);
        }
      }
      var blockType = type === 'normal' ? 'function_create' : 'function_create_value';
      var block;
      func.content.getThreads().some(function (thread, idx) {
        var target = thread.getFirstBlock();
        if (target instanceof Entry.Block && ['function_create_value', 'function_create'].includes(target === null || target === void 0 ? void 0 : target.type)) {
          tempContent[idx][0].type = blockType;
          block = target;
          return true;
        }
      });
      block.changeType(blockType);
      func.content = new Entry.Code(tempContent);
      var workspace = Entry.getMainWS();
      workspace.changeOverlayBoardCode(func.content);
      func.block = block;
      Entry.variableContainer.updateList();
      EntryFunc.registerFunction(func);
      EntryFunc.generateWsBlock(func, true);
      EntryFunc.updateMenu();

      // reDrawVariableContainer()

      // b = Entry.variableContainer.getFunction(/(func_)?(.*)/.exec('0q91')[2]);
      // Entry.Func.changeType(b, 'value')
    }
  }, {
    key: "_generateFunctionSchema",
    value: function _generateFunctionSchema(functionId) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';
      var isUpdate = arguments.length > 2 ? arguments[2] : undefined;
      var prefixedFunctionId = "func_".concat(functionId);
      if (!isUpdate && Entry.block[prefixedFunctionId]) {
        return;
      }
      var BlockSchema = function BlockSchema() {};
      BlockSchema.prototype = Entry.block.function_general;
      if (type === 'value') {
        BlockSchema.prototype = Entry.block.function_value;
      }
      BlockSchema = new BlockSchema();
      BlockSchema.changeEvent = new Entry.Event();
      BlockSchema.template = Lang.template.function_general;
      if (type === 'value') {
        BlockSchema.template = Lang.template.function_value;
      }
      Entry.block[prefixedFunctionId] = BlockSchema;
    }

    /**
     * 이전 워크스페이스 보드 형태가 VIMBOARD 였던 경우면 VIMBOARD 로 돌린다.
     * @private
     */
  }, {
    key: "_restoreBoardToVimBoard",
    value: function _restoreBoardToVimBoard() {
      var ws = Entry.getMainWS();
      if (ws && ws.overlayModefrom === Entry.Workspace.MODE_VIMBOARD) {
        ws.setMode({
          boardType: Entry.Workspace.MODE_VIMBOARD,
          textType: Entry.Vim.TEXT_TYPE_PY,
          runType: Entry.Vim.WORKSPACE_MODE
        });
        Entry.variableContainer.functionAddButton_.addClass('disable');
      }
    }
  }]);
}();
(0, _defineProperty2["default"])(EntryFunc, "isEdit", false);
(0, _defineProperty2["default"])(EntryFunc, "threads", {});
Entry.Func = EntryFunc;